import LoginName from './LoginName';
import './style/login-name.less';

export default LoginName;
